import { render, staticRenderFns } from "./SettingsPersonalTime.vue?vue&type=template&id=667fd38d&scoped=true&"
import script from "./SettingsPersonalTime.vue?vue&type=script&lang=js&"
export * from "./SettingsPersonalTime.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPersonalTime.vue?vue&type=style&index=0&id=667fd38d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667fd38d",
  null
  
)

component.options.__file = "SettingsPersonalTime.vue"
export default component.exports